import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Progress } from "semantic-ui-react";
import { downloadCSVData } from "../utils";
import { Icon } from "semantic-ui-react";
import NoData from "../NoData/NoData";
import * as d3 from "d3";
import _ from "lodash";
import "./TopInfluencers.scss";
import { numberWithCommas } from "../utils";
import { Scrollbars } from "react-custom-scrollbars";
import ImpactSelector from "../ImpactSelectors";
import InfluencerSelector from "../InfluencerSelectors";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import DownloadChart from "../DownloadChart";

import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
class TopInfluencers extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            sortType: "tot-impact",
            gender: "",
            influencerType: "all",
            showInfo: false,
        };
        // this.url_prefix = "https://2020admin.circussocial.com/image/image.php?type=post_author_images&name=";
        this.url_prefix = "https://2020assets.s3.amazonaws.com/images/post_author_images";
        this.chartEl = React.createRef();
    }
    handleImpactChange = (val) => {
        this.props.fetchDataFromWidget({
            arrangeBy: val,
        });
    };

    handleInfluencerChange = (val) => {
        this.props.fetchDataFromWidget({
            sentiment: val !== "yes" ? val : "",
        });
    };

    getProfileImage(post) {
        if (post._source.post_author.media[0].folder && post._source.post_author.media[0].name) {
            return this.url_prefix + post._source.post_author.media[0].folder.replace("post_author_images", "") + "/" + post._source.post_author.media[0].name;
        } else {
            return process.env.PUBLIC_URL + "/icons/charts/platformIcons/user_blank.png";
        }
    }

    renderPostCount(count) {
        if (count) {
            return <p className="popup-post-count"> Post Count: &nbsp;&nbsp; {count} </p>;
        } else {
            return null;
        }
    }

    getPlatformData(platform) {
        let following = platform.user_latest_post.hits.hits[0]._source.post_author.following
            ? platform.user_latest_post.hits.hits[0]._source.post_author.following
            : "N/A";
        let followers = platform.user_latest_post.hits.hits[0]._source.post_author.followers
            ? platform.user_latest_post.hits.hits[0]._source.post_author.followers
            : "N/A";
        let postCount = platform.user_latest_post.hits.hits[0]._source.post_author.post_count;
        let tweets = platform.user_latest_post.hits.hits[0]._source.post_author.tweets;
        return (
            <section className="popup-content">
                <section>
                    <img className="user-profile-image" src={this.getProfileImage(platform.user_latest_post.hits.hits[0])} alt="" />
                    <span>
                        <p className="popup-username"> {platform.user_latest_post.hits.hits[0]._source.post_author.username} </p>
                        <p className="popup-authorname"> {platform.user_latest_post.hits.hits[0]._source.post_author.name} </p>
                    </span>
                </section>
                <p className="popup-following"> Following: &nbsp;&nbsp; {following} </p>
                <p className="popup-followers"> Followers: &nbsp;&nbsp; {followers} </p>
                {tweets !== null && tweets !== undefined && platform.key === "twitter" && <p className="popup-tweets"> Tweets: &nbsp;&nbsp; {tweets} </p>}
                {this.renderPostCount(postCount)}
                <p className="popup-location"> Location: &nbsp;&nbsp; {platform.user_latest_post.hits.hits[0]._source.post_author.location || "N/A"} </p>
            </section>
        );
    }

    getPlatforms(platforms) {
        const allPlatforms = [
            {
                id: "6ce33762-a789-11e4-a34f-74867a1157ba",
                name: "Blog",
                short_name: "blog",
            },
            {
                id: "9341868e-0966-11e7-9283-0656fc34e8c9",
                name: "China-Blogs",
                short_name: "blogschina",
            },
            {
                id: "6ce338bd-a789-11e4-a34f-74867a1157ba",
                name: "Facebook",
                short_name: "facebook",
            },
            {
                id: "669ed73b-3102-11e5-b4bb-22000aa22ef0",
                name: "Facebook Comments",
                short_name: "fbcomment",
            },
            {
                id: "6ce32185-a789-11e4-a34f-74867a1157ba",
                name: "Forums",
                short_name: "forum",
            },
            {
                id: "0a789dba-0967-11e7-9283-0656fc34e8c9",
                name: "China-Forums",
                short_name: "forumschina",
            },
            {
                id: "6ce32c0a-a789-11e4-a34f-74867a1157ba",
                name: "Instagram",
                short_name: "instagram",
            },
            {
                id: "8de7e53a-ad28-11e4-b8cb-22000aa425f3",
                name: "LexisNexis",
                short_name: "lexisnexis",
            },
            {
                id: "6ce32911-a789-11e4-a34f-74867a1157ba",
                name: "News",
                short_name: "news",
            },
            {
                id: "28030c45-0967-11e7-9283-0656fc34e8c9",
                name: "China-News",
                short_name: "newschina",
            },
            {
                id: "7f18d34a-367f-11e9-b7dd-02eebbc40807",
                name: "Q&A",
                short_name: "q&a",
            },
            {
                id: "ba447faa-ad28-11e4-b8cb-22000aa425f3",
                name: "Reddit",
                short_name: "reddit",
            },
            {
                id: "6ce33065-a789-11e4-a34f-74867a1157ba",
                name: "China-Weibo",
                short_name: "weibo",
            },
            {
                id: "6ce32a97-a789-11e4-a34f-74867a1157ba",
                name: "Twitter",
                short_name: "x_icon",
            },
            {
                id: "6ce32d7c-a789-11e4-a34f-74867a1157ba",
                name: "Youtube",
                short_name: "youtube",
            },
            {
                id: "8bbdf46a-3680-11e9-b7dd-02eebbc40807",
                name: "China-WeChat",
                short_name: "wechat",
            },
            {
                id: "b58cda8d-c22d-11e8-b7dd-02eebbc40807",
                name: "LinkedIn",
                short_name: "linkedin_icon",
            },
            {
                id: "1cbacd32-a97d-11ea-89d1-02f9d9f14362",
                name: "TikTok",
                short_name: "tiktok",
            },
        ];
        // console.log("platform", platforms);
        return (
            <div className="platform-icons">
                {platforms.map((platform) => {
                    let platformName = allPlatforms.find((plt) => plt.id === platform.key);
                    platformName = platformName ? platformName.short_name : "";
                    platformName = ["fbcomment", "facebook comments"].includes(platformName) ? "facebook" : platformName;
                    return platformName.length > 0 ? (
                        <Popup
                            key={platform.key}
                            trigger={<img className="platform-icon" src={process.env.PUBLIC_URL + "/icons/charts/platformIcons/" + platformName + ".png"} />}
                            content={this.getPlatformData(platform)}
                            wide
                        />
                    ) : null;
                })}
            </div>
        );
    }

    getUserGender(gender) {
        if (gender === "male") return <Icon size="large" name="man" />;
        if (gender === "female") return <Icon size="large" name="woman" />;
        return <Icon size="large" name="genderless" />;
    }

    getAvgImpact(impact, max_avg_impact) {
        let percent = 0;
        if (impact.max !== null && impact.avg !== null && impact.max !== 0) {
            percent = Math.round((impact.avg / max_avg_impact) * 100);
        }
        return <Progress className="avg-impact-progress" size="small" percent={percent} success title={impact.avg || 0} />;
    }

    getAvgSentiment(sentiment) {
        let percent = 0;
        if (sentiment.max !== null && sentiment.avg !== null && sentiment.max !== 0) {
            percent = Math.abs(Math.round((sentiment.avg / 20) * 100));
        }
        return (
            <Progress
                className="avg-impact-progress"
                size="small"
                percent={percent}
                success={sentiment.avg > 0}
                error={sentiment.avg < 0}
                title={(sentiment.avg / 20).toFixed(2)}
            />
        );
    }

    handleContextMenu(e, influencer) {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");
        e.preventDefault();
        contextMenu.style("top", `${e.clientY}px`);
        contextMenu.style("left", `${e.clientX}px`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(influencer);
            });
        contextMenu
            .append("li")
            .text("View Insights")
            .on("click", () => {
                // console.log('drilldown')
                self.handleDrilldownClick(influencer);
                // this.props.showChartsDrilldown(true, "topicWiseSentimentBreakup");
            });

        contextMenu.style("display", "block");
    }

    createNewFilter(influencer) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};

        newFilter.extras = [{ key: "User", value: influencer.key }];
        if (this.props.appliedFilter.sentiment === "positive") newFilter.extras.push({ key: "Sentiment", value: "positive" });
        else if (this.props.appliedFilter.sentiment === "negative") newFilter.extras.push({ key: "Sentiment", value: "negative" });

        return newFilter;
        // this.props.handleContextMenuClick(newFilter);
    }

    handleContextMenuClick = (influencer) => {
        let newFilter = this.createNewFilter(influencer);

        this.props.handleContextMenuClick(newFilter);
    };

    handleDrilldownClick(influencer) {
        let newFilter = this.createNewFilter(influencer);

        this.props.handleDrilldownClick(newFilter);
    }

    renderDownloadButton(nodata) {
        return <DownloadChart nodata={nodata} options={[{ name: "CSV", downloadFn: this.downloadCSV }]} />;
    }

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let csvFmt = [
            [
                "Userid",
                "Name",
                "PostCount",
                "Tweets",
                "Mentions",
                "Avg-impact",
                "Max-impact",
                "Min-impact",
                "Impact-count",
                "Avg-sentiment",
                "Max-sentiment",
                "Min-sentiment",
                "Sentiment-count",
                "Followers",
                "Following",
                "Gender",
            ],
        ];
        this.props.data.forEach((influencer) => {
            csvFmt.push([
                `${influencer.key}`,
                `${
                    influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.name != null
                        ? influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.name
                        : "N/A"
                }`,
                influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.post_count,
                influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.tweets,
                influencer.doc_count,
                influencer.impact_stats.avg || 0,
                influencer.impact_stats.max || 0,
                influencer.impact_stats.min || 0,
                influencer.impact_stats.count || 0,
                influencer.sentiment_score_stats.group1.group2.avg || 0,
                influencer.sentiment_score_stats.group1.group2.max || 0,
                influencer.sentiment_score_stats.group1.group2.min || 0,
                influencer.sentiment_score_stats.group1.group2.count || 0,
                influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.followers || 0,
                influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.following || 0,
                influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.gender || "unknown",
            ]);
        });
        downloadCSVData(csvFmt, this.props.widget.name);
    };

    getMaxAvgImpact = () => {
        let maxVal = 0;
        this.props.data.forEach((e) => {
            if (e.impact_stats.avg > maxVal) maxVal = e.impact_stats.avg;
        });
        return maxVal;
    };

    render() {
        let max_avg_impact = !this.props.data ? 0 : this.getMaxAvgImpact();
        let nodata = !this.props.data || (this.props.data && this.props.data.length === 0) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName name={this.props.widget.name} info="Represents top influencers for the given filters." />
                    <div className="dashboard-widget-actions selector-style" data-html2canvas-ignore="true">
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && <>{this.renderDownloadButton(nodata)}</>}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && (
                            <ImpactSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleImpactChange={this.handleImpactChange}
                            />
                        )}
                        {!nodata && (
                            <InfluencerSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleInfluencerChange={this.handleInfluencerChange}
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div ref={this.chartEl} className="dashboard-chart table-wrapper skiptranslate">
                        <Scrollbars autoHide>
                            <div className="top-influencer-table">
                                <div className="top-influencer-table-cell"></div>
                                <div className="top-influencer-table-cell">Name</div>
                                <div className="top-influencer-table-cell">Total Impact</div>
                                <div className="top-influencer-table-cell">Avg Impact</div>
                                <div className="top-influencer-table-cell">Avg Sentiment</div>
                                <div className="top-influencer-table-cell">Mentions</div>
                                <div className="top-influencer-table-cell">Gender</div>
                                <div className="top-influencer-table-cell">Location</div>

                                {this.props.data &&
                                    this.props.data.map((influencer, ind) => {
                                        if (
                                            (influencer.platform_breakups &&
                                                influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.name) ||
                                            influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.username
                                        ) {
                                            return (
                                                <>
                                                    <div
                                                        className="profile-dets top-influencer-table-cell"
                                                        onContextMenu={(e) => this.handleContextMenu(e, influencer)}>
                                                        <img
                                                            crossOrigin="anonymous"
                                                            className="user-profile-image"
                                                            src={this.getProfileImage(influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0])}
                                                            alt=""
                                                        />
                                                        {this.getPlatforms(influencer.platform_breakups.buckets)}
                                                    </div>
                                                    <div
                                                        className="authorname top-influencer-table-cell"
                                                        onContextMenu={(e) => this.handleContextMenu(e, influencer)}>
                                                        {influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.name ||
                                                            influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.username}
                                                    </div>
                                                    <div
                                                        className="total-impact top-influencer-table-cell"
                                                        onContextMenu={(e) => this.handleContextMenu(e, influencer)}>
                                                        {numberWithCommas(influencer.impact_stats.sum) || "N/A"}
                                                    </div>
                                                    <div
                                                        className="one-avg-impact top-influencer-table-cell"
                                                        onContextMenu={(e) => this.handleContextMenu(e, influencer)}>
                                                        {this.getAvgImpact(influencer.impact_stats, max_avg_impact)}
                                                    </div>
                                                    <div
                                                        className="one-avg-sentiment top-influencer-table-cell"
                                                        onContextMenu={(e) => this.handleContextMenu(e, influencer)}>
                                                        {this.getAvgSentiment(influencer.sentiment_score_stats.group1.group2)}
                                                    </div>
                                                    <div
                                                        className="mentions top-influencer-table-cell"
                                                        onContextMenu={(e) => this.handleContextMenu(e, influencer)}>
                                                        {" "}
                                                        {numberWithCommas(influencer.doc_count)}{" "}
                                                    </div>
                                                    <div
                                                        className="gender top-influencer-table-cell"
                                                        onContextMenu={(e) => this.handleContextMenu(e, influencer)}>
                                                        {this.getUserGender(
                                                            influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.gender,
                                                        )}
                                                    </div>
                                                    <div
                                                        className="location top-influencer-table-cell"
                                                        onContextMenu={(e) => this.handleContextMenu(e, influencer)}>
                                                        {influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.location ||
                                                            "N/A"}
                                                    </div>
                                                </>
                                            );
                                        }
                                    })}
                            </div>
                        </Scrollbars>
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        // data: state.csApiReducer.topInfluencers,
        //allPlatforms: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.platforms : [],
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

export default connect(mapStateToProps)(TopInfluencers);
